export default __webpack_public_path__ + "static/lilypads-7565eb99a65dab1dc61fc61c882c3a99.jpg";